<rt-dialog-body variant="white">
  <div class="content-container">
    <div class="left">
      <rt-heading class="heading" variant="large-x-dialog-header bold dark">
        {{ 'tlc.positions.skills_ideate_flow.intro.heading' | translate }}
      </rt-heading>

      <span class="subheading">{{
        'tlc.positions.skills_ideate_flow.intro.subheading' | translate
      }}</span>

      <rt-feature-discovery-stepper [steps]="steps" />
    </div>
    <div class="right">
      <img
        class="intro-illustration"
        ngSrc="assets/images/tellent-skills/generate-skills-template-intro.svg"
        alt=""
        [width]="266"
        [height]="348"
      />
    </div>
  </div>
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true" innerPadding="small">
  <div class="optional">
    <rt-checkbox [formControl]="dontShowAgainControl">
      {{ 'tlc.positions.skills_ideate_flow.intro.dont_show_again' | translate }}
    </rt-checkbox>
  </div>
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button variant="primary" (click)="continue()">
    <span>{{ 'tlc.common.continue' | translate }}</span>
    <rt-icon name="arrow-forward" />
  </rt-button>
</rt-dialog-footer>
